<p-table
    #dt
    [value]="rows"
    [columns]="columns"
    [paginator]="rows.length > 10"
    [rows]="25"
    [customSort]="true"
    sortMode="multiple"
    (sortFunction)="customSort($event)"
    [totalRecords]="rows.length"
    [rowsPerPageOptions]="[10, 25, 50, { showAll: uiPipe('view.search.all') }]"
    class="tableStickyHeader"
    [loading]="loading"
    [hisFrozencol]="frozenCol">
    <ng-template
        pTemplate="header"
        let-columns>
        <!-- Für Berichte ohne hierarchischem Header (column header) -->
        @if (!tableHeader) {
            @if (isReorderable) {
                <tr>
                    @for (col of columns; track col) {
                        <th pReorderableColumn>
                            <button
                                hisImage="ARROW_LEFT"
                                (click)="hisReorderTableService.moveRowOrColumn(columns, col, -1)"
                                class="icon"
                                name="reorderTable"
                                title="{{ 'reorder.arrow_left' | hisUi }}"></button>
                            {{ col.header }}
                            <button
                                hisImage="ARROW_RIGHT"
                                (click)="hisReorderTableService.moveRowOrColumn(columns, col, 1)"
                                class="icon"
                                name="reorderTable"
                                title="{{ 'reorder.arrow_right' | hisUi }}"></button>
                        </th>
                    }
                </tr>
            }
            @if (!isReorderable) {
                <tr>
                    @for (column of columns; track column) {
                        <th
                            [pSortableColumn]="column.field"
                            [pSortableColumnDisabled]="
                                column.type === columnType.DetailColumn ||
                                column.type === columnType.EditColumn
                            "
                            style="white-space: pre-line">
                            {{ column.header }}
                        </th>
                    }
                </tr>
            }
            @if (filterActive) {
                <tr>
                    @for (column of columns; track column) {
                        <th>
                            <input
                                #filterInput
                                pInputText
                                type="text"
                                class="p-column-filter"
                                placeholder="{{ 'cs.bia.common.search' | hisUi }}"
                                (input)="dt.filter(filterInput.value, column.field, 'contains')"
                                [value]="
                                    dt.filters[column.field]
                                        ? $any(dt.filters[column.field]).value
                                        : ''
                                " />
                        </th>
                    }
                </tr>
            }
        }
        <!-- Für Berichte mit hierarchischem Header (row header) -->
        @if (tableHeader) {
            @for (row of tableHeader.headerRows; track row) {
                <tr>
                    @for (element of row.headerElements; track element) {
                        @if (element.column) {
                            <th
                                [attr.rowspan]="element.rowspan"
                                [attr.colspan]="element.colspan"
                                [pSortableColumn]="
                                    element.column.type !== columnType.HierarchyLevelColumn &&
                                    element.column.refColumnField
                                        ? element.column.refColumnField
                                        : element.column.field
                                "
                                [pSortableColumnDisabled]="
                                    !element.sortIcon ||
                                    element.column.type === columnType.DetailColumn ||
                                    element.column.type === columnType.EditColumn
                                "
                                style="white-space: pre-line">
                                {{ element.caption }}
                            </th>
                            @if (filterActive) {
                                <tr>
                                    @for (column of columns; track column) {
                                        <th>
                                            <input
                                                #filterInput
                                                pInputText
                                                type="text"
                                                class="p-column-filter"
                                                placeholder="{{ 'cs.bia.common.search' | hisUi }}"
                                                (input)="
                                                    dt.filter(
                                                        filterInput.value,
                                                        column.field,
                                                        'contains'
                                                    )
                                                "
                                                [value]="
                                                    dt.filters[column.field]
                                                        ? $any(dt.filters[column.field]).value
                                                        : ''
                                                " />
                                        </th>
                                    }
                                </tr>
                            }
                        }
                    }
                </tr>
            }
        }
    </ng-template>
    <!-- Zeilen -->
    <ng-template
        pTemplate="body"
        let-row
        let-columns="columns">
        <tr>
            @for (col of columns; track col) {
                <td [class.textAlignRight]="col.type === columnType.DecimalColumn">
                    {{ row[col.field] | biaColumnFormat: col.type }}
                </td>
            }
        </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright"> </ng-template>
</p-table>
